<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>
        <span>{{title}}</span>
        <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{iconname}}</mat-icon>
    </h1>
    <div class="centerwrap scroll" fxFlex.gt-sm="auto" fxFlex.lt-md="100" #scrollpanel>
        <div [innerHTML]="message | safeHTML"></div>
        <form [formGroup]="SearchForm" novalidate (ngSubmit)="HandleUserSearch()">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <mat-form-field *ngIf="PersonType == 'EMPLOYEE'" appearance="outline">
                    <input type="text" matInput formControlName="SAPID" placeholder="SAPID..." maxlength="8" autofocus #sapid />
                    <mat-hint align="start" *ngIf="!SearchForm?.get('SAPID')?.hasError('pattern')">Numeric values only</mat-hint>
                    <mat-error align="start" *ngIf="SearchForm?.get('SAPID')?.hasError('pattern')">Numbers only, please.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="PersonType == 'STUDENT'" appearance="outline">
                    <input type="text" matInput formControlName="StudentID" placeholder="StudentID..." maxlength="10" autofocus #studentid />
                    <mat-hint align="start" *ngIf="!SearchForm?.get('StudentID')?.hasError('pattern')">Numeric values only</mat-hint>
                    <mat-error align="start" *ngIf="SearchForm?.get('StudentID')?.hasError('pattern')">Numbers only, please.</mat-error>
                </mat-form-field>
                <button type="submit" mat-raised-button color="primary" [disabled]="!SearchForm.valid">Search</button>
                <button type="button" mat-raised-button color="warn" (click)="ResetForm()">Reset</button>
            </div>
        </form>
        <div *ngIf="UserSearchConducted">
            <table mat-table class="fullwidth" [dataSource]="ResultsData" matSort matSortActive="LastName">
                <ng-container matColumnDef="LastName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Last Name</th>
                    <td mat-cell *matCellDef="let user">
                        <span>{{user.LastName | titleCase}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="FirstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">First Name</th>
                    <td mat-cell *matCellDef="let user">
                        <span>{{user.FirstName | titleCase}}</span>
                    </td>
                </ng-container>

                <div *ngIf="PersonType == 'EMPLOYEE'">
                    <ng-container matColumnDef="SAPID">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">SAPID</th>
                        <td mat-cell *matCellDef="let user">
                            <span>{{user.SAPID}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="PositionNo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Position #</th>
                        <td mat-cell *matCellDef="let user">
                            <span>{{user.PositionNo}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="LocalJobTitle">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
                        <td mat-cell *matCellDef="let user">
                            <span>{{user.LocalJobTitle}}</span>
                        </td>
                    </ng-container>
                </div>

                <ng-container matColumnDef="StudentID" *ngIf="PersonType == 'STUDENT'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">StudentID</th>
                    <td mat-cell *matCellDef="let user">
                        <span>{{user.StudentID}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <th mat-header-cell *matHeaderCellDef>Action(s)</th>
                    <td mat-cell *matCellDef="let user">
                        <button type="button" mat-raised-button color="primary" (click)="SelectUser(user)">{{oktext}}</button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="NoData">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let user" [attr.colspan]="VisibleHeaders.length">
                        <em>No search results were found with the provided search criteria.</em>
                    </td>
                </ng-container>

                <ng-container matColumnDef="SmallDisplay">
                    <th mat-header-cell *matHeaderCellDef>Search Result(s)</th>
                    <td mat-cell *matCellDef="let user">
                        <div fxLayout="column" fxLayoutAlign="start stretch" class="margin-bottom">
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <strong>First Name:</strong>
                                <span>{{user.FirstName | titleCase}}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <strong>Last Name:</strong>
                                <span>{{user.LastName | titleCase}}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <strong>SAPID:</strong>
                                <span>{{user.SAPID}}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <strong>StudentID:</strong>
                                <span>{{user.StudentID}}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <strong>Position #:</strong>
                                <span>{{user.PositionNo}}</span>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="start stretch">
                                <strong>Title:</strong>
                                <span>{{user.LocalJobTitle}}</span>
                            </div>
                            <!-- Action button(s) -->
                            <button type="button" mat-raised-button color="primary" (click)="SelectUser(user)"></button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="VisibleHeaders"></tr>
                <tr mat-row *matRowDef="let row; columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></tr>
            </table>
        </div>
    </div>
    <div class="margin-top" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="center center" fxLayoutGap.lt-md="10px">
        <button mat-raised-button color="warn" (click)="CancelHandler()">{{canceltext}}</button>
    </div>
</div>
